import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Important: react-i18next v7 lit sa config via la clé "react" ci-dessous.
i18n.use(XHR) // charge /public/locales/{{lng}}/{{ns}}.json via XHR
    .use(LanguageDetector) // détecte la langue (query, cookie, localStorage, navigator)
    .init({
        fallbackLng: "en", // langue par défaut
        whitelist: ["en", "fr", "nl"], // (ou supportedLngs dans versions plus récentes)
        ns: ["translations"], // namespaces utilisés
        defaultNS: "translations",

        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
            crossDomain: false
        },

        detection: {
            order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
            caches: ["localStorage", "cookie"]
        },

        interpolation: {
            escapeValue: false // React échappe déjà
        },

        // Options spécifiques à react-i18next v7
        react: {
            wait: true, // évite le flash de texte non traduit
            bindI18n: "languageChanged loaded"
        },

        debug: false
    });

export default i18n;
